<template>
	<div class="component-navigator-drawer flex">
		<span
			class="name flex items-center cursor-pointer whitespace-nowrap hover:bm-text-effect"
			:class="[size, { active: show }]"
			@click="show = true"
		>
			<svg
				class="svgfont bm-size-6"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				width="512"
				height="512"
				viewBox="0 0 512 512"
			>
				<path
					fill="currentColor"
					d="M496 96h-480v53.334h480v-53.334zM496 229.334h-480v53.333h480v-53.333zM496 362.666h-240v53.334h240v-53.334z"
				/>
			</svg>
		</span>
		<client-only>
			<el-drawer
				class="drawer"
				v-model="show"
				:direction="$attrs.direction || 'rtl'"
				:modal="$attrs.modal || false"
				size="320px"
			>
				<div class="container bm-text-black pb-5 overflow-auto">
					<div class="px-5 pb-3 flex flex-col items-center bmmd:hidden" v-if="!isLogined">
						<nuxt-link-enhance
							class="font-medium bm-size-3_5 leading-[18px] hover:bm-text-effect"
							project="www"
							:to="computedLoginRoute"
						>
							{{ $t('bmui-navigator-bar.common_sign_in') }}
						</nuxt-link-enhance>
						<nuxt-link-enhance
							class="flex justify-center items-center w-full h-10 mt-5 rounded bm-text-white bm-bg-effect font-medium bm-size-3_5 leading-[18px] hover:bm-bg-effect-300 active:bm-bg-effect-600"
							project="www"
							:to="computedRegisterRoute"
						>
							{{ $t('bmui-navigator-bar.common_register') }}
						</nuxt-link-enhance>
					</div>

					<CollapseMenuPicker class="mt-4 bmmd:hidden" :title="userName" @change="getUserAssets" v-if="isLogined">
						<AccountOverviewCard class="px-5 pb-4" :datas="assetsData" />
					</CollapseMenuPicker>

					<!-- 本来想让个人信息吸顶，但是移动端空间本来就少，还是放弃了 -->
					<!-- 移动端登陆之后 -->
					<div
						class="border-0 border-t border-solid bm-bd-gray-200 bmmd:hidden"
						v-if="isLogined && $$AUTH_ROUTES_CONFIG.length > 0"
					>
						<!-- 作了结构化处理，单独抽出来 -->
						<div v-for="item in $$AUTH_ROUTES_CONFIG" :key="item.value">
							<SensorTrack :datas="item.sensorData" v-if="item.show">
								<nuxt-link-enhance
									class="h-[50px] box-border flex items-center px-5 py-3 bm-size-3_5 leading-6 font-medium cursor-pointer hover:bm-bg-gray-100"
									:project="item.project"
									:to="item.to"
									exact
								>
									{{ $t(item.name) }}
								</nuxt-link-enhance>
							</SensorTrack>
						</div>
					</div>

					<div
						class="border-0 border-t border-solid bm-bd-gray-200 bmxl:hidden bmmd:border-t-0"
						v-if="commonRoutes.length > 0"
					>
						<div class="bm-col flex-grow-0" v-for="item in commonRoutes" :key="item.value">
							<SensorTrack :datas="item.sensorData" v-if="item.type === 'single'">
								<nuxt-link-enhance
									class="h-[50px] box-border flex items-center px-5 py-3 bm-size-3_5 leading-6 font-medium cursor-pointer hover:bm-bg-gray-100"
									:class="[size]"
									:project="item.project"
									:to="item.to"
									exact
								>
									{{ getTranslate(item.nameLangList, item.name) }}

									<span
										class="bm-bg-effect-trans bm-text-effect font-medium rounded text-xs h-4 leading-4 px-1 ml-[2px]"
										v-if="item.label"
										>{{ $t(item.label) }}</span
									>
								</nuxt-link-enhance>
							</SensorTrack>

							<CollapseMenuPicker
								:title="getTranslate(item.nameLangList, item.name)"
								:list="item.list"
								v-if="item.type === 'group'"
							/>
						</div>
						<CollapseMessage />
					</div>

					<CollapseMenuPicker
						class="border-0 border-t border-solid bm-bd-gray-200 bmlg:hidden"
						:title="$t('bmui-navigator-bar.common_app_download_title')"
					>
						<div class="flex justify-center p-5"><AppQRCode /></div>
					</CollapseMenuPicker>

					<CollapseMenuPicker class="bmlg:hidden" :title="$t('bmui-navigator-bar.common_language_picker')">
						<div class="px-5 pt-2 pb-4"><LanguageList :list="languageList" /></div>
					</CollapseMenuPicker>

					<!-- 只在大pad横屏出现 -->
					<!-- 小pad也出现 -->
					<div class="px-4 py-6 hidden bmlg:block bmlg:border-0 bmlg:border-t bmlg:border-solid bmlg:bm-bd-gray-200">
						<div class="bm-size-3_5 leading-6 font-medium mb-6">
							{{ $t('bmui-navigator-bar.common_app_download_title') }}
						</div>
						<div class="flex justify-center"><AppQRCode /></div>
					</div>
					<!-- @TODO这里看看能不能用jsx语法写成扩展子组件的方式 -->
					<div class="px-4 py-6 border-0 border-t border-solid bm-bd-gray-200 hidden bmlg:block">
						<div class="bm-size-3_5 leading-6 font-medium mb-6">
							{{ $t('bmui-navigator-bar.common_language_picker') }}
						</div>
						<LanguageList :list="languageList" />
					</div>

					<!-- 登出 -->
					<div class="border-0 border-t border-solid bm-bd-gray-200 bmmd:hidden" v-if="isLogined">
						<div
							class="h-[50px] box-border flex items-center px-5 py-2 bm-size-3_5 leading-6 font-medium cursor-pointer hover:bm-bg-gray-100 bmmd::h-10"
							@click="$$logout"
						>
							<sensor-track
								:datas="{
									sensorEventName: 'ClickTopBar',
									module_name: '我的',
									button_name: '我的（退出登录）',
								}"
							>
								<span>{{ $t('bmui-navigator-bar.common_sign_out') }}</span>
							</sensor-track>
						</div>
					</div>
				</div>
			</el-drawer>
		</client-only>
	</div>
</template>

<script>
import _get from 'lodash/get';
import commonMixins from '../mixins';
import { PROJECT_MAP } from '../config';
import SensorTrack from './SensorTrack';
import { LANGUAGE_LIST } from './DropdownLanguagePicker';
import AppQRCode from './AppQRCode';
import CollapseMenuPicker from './CollapseMenuPicker';
import AccountOverviewCard from './AccountOverviewCard';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import ComponentLanguageList from './ComponentLanguageList';
import { usePatchStore } from '~/common/js/patch';
import { isLoginedToken } from '~/common/js/utils';
import i18nMessage from '../i18n';
import CollapseMessage from './message/CollapseMessage.vue';
// const ComponentLanguageList = {
//   mixins: [commonMixins],

//   props: {
//     list: {
//       type: Array,
//       default () {
//         return [];
//       },
//     },
//   },
//   computed: {
//     ...mapState({
//       locale: state => state.locale,
//     }),
//   },
//   render () {
//     return (
//       <ul class="flex bm-row bm-row-cols-3 bm-gy-4 bm-gx-1 bm-size-3_5 leading-6">
//         {this.list.map(item => (
//           <li
//             style={{ flex: 'initial', width: 'auto' }}
//             class={{
//               'bm-col': true,
//               'box-border': true,
//               'cursor-pointer': true,
//               'hover:bm-text-effect': true,
//               'actived:bm-text-effect': item.value === ((OLD_LOCALES_OBJ_REVERSE || {})[this.locale] || this.locale),

//             }}
//             onClick={() => {
//               this.$$switchLanguage(item.value);
//             }}
//           >
//             {item.title || item.name}
//           </li>
//         ))}
//       </ul>
//     );
//   },
// };

export default {
	name: 'DropdownLanguagePicker',
	components: {
		AppQRCode,
		NuxtLinkEnhance,
		SensorTrack,
		AccountOverviewCard,
		CollapseMenuPicker,
		LanguageList: ComponentLanguageList,
		CollapseMessage
	},

	mixins: [commonMixins],

	props: {
		size: { type: String, default: 'normal' },
		project: {
			type: String,
			default: PROJECT_MAP.MASTER,
		},
		commonRoutesConfig: {
			type: Array,
			default() {
				return [];
			},
		},
	},

	data() {
		return {
			show: false,
			languageConfig: LANGUAGE_LIST,
			assetsData: {},
			isLogined: false,
		};
	},
	computed: {
		// @TODO userName的取值要改一下
		locale() {
			return this.store.locale;
		},
		userName() {
			return this.store.userName || this.store.account.loginName;
		},
		localeConfigList() {
			return this.store.localeConfigList;
		},
		canUseSubAccount() {
			return this.getters('account/canUseSubAccount');
		},
		languageList() {
			if (!this.localeConfigList || !this.localeConfigList.length) {
				return LANGUAGE_LIST;
			}
			return this.localeConfigList.map((item) => ({
				show: true,
				value: item.locale,
				name: item.name,
				sensorData: {
					sensorEventName: 'ClickTopBar',
					module_name: '选择语言',
					button_name: item.name,
				},
			}));
		},
		computedLoginRoute() {
			// 如果当前路由地址是是合约赠金活动(/bonus-giveaway)，则使用不同的路由地址，GIVEAWAY_INVITE
			const currentRouteName = this.$route.name;

			if (currentRouteName === 'bonus-giveaway-lang') {
				return {
					path: '/login',
					query: {
						inviteType: 'BONUS_GIVEAWAY',
					},
				};
			} else {
				return {
					path: '/login',
				};
			}
		},
		computedRegisterRoute() {
			// 如果当前路由地址是是合约赠金活动(/bonus-giveaway)，则使用不同的路由地址，GIVEAWAY_INVITE
			const currentRouteName = this.$route.name;

			if (currentRouteName === 'bonus-giveaway-lang') {
				return {
					path: '/register',
					query: {
						inviteType: 'BONUS_GIVEAWAY',
					},
				};
			} else {
				return {
					path: '/register',
				};
			}
		},
		commonRoutes() {
			return this.project === PROJECT_MAP.DERIVATIVES ? this.$$FUTURES_ROUTES_CONFIG : this.commonRoutesConfig;
		},
	},
	methods: {
		getUserAssets(expand) {
			if (!this.isLogined) {
				return;
			}
			// 通过折叠面板打开并且为0时，不请求新数据
			if (expand && expand.length === 0) {
				return;
			}

			this.$$getUserAssets()
				.then((resData) => {
					if (!resData?.success) {
						return;
					}
					this.assetsData = resData.data;
				})
				.catch((e) => {
					console.log(e);
				});
		},

		getTranslate(langList, defaultValue) {
			const i18nExist = _get(i18nMessage?.[this.$$locale], defaultValue);

			let val = '';
			if (langList?.[this.$$transRouteLocale]) {
				val = langList?.[this.$$transRouteLocale];
			} else if (i18nExist) {
				val = defaultValue;
			} else {
				val = langList?.['en-US'] || defaultValue;
			}

			return val ? this.$t(val) : val;
		},
	},
	mounted() {
		this.isLogined = isLoginedToken();
	},
	watch: {
		// 只要路由发生变化，就关掉抽屉窗
		$route() {
			this.show = false;
		},
		show() {
			// 每次打开后，都会预拉取一次资产数据
			if (!this.show) {
				return;
			}
			this.getUserAssets();
		},
		userName(v) {
			if (v) {
				this.isLogined = isLoginedToken();
			}
		},
	},
	setup() {
		const { store, getters } = usePatchStore();
		return {
			store,
			getters,
		};
	},
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-navigator-drawer {
	:deep(.el-drawer) {
		box-shadow: 0px 8px 36px rgba(205, 218, 218, 0.4);
	}

	:deep(.el-drawer__header) {
		margin-bottom: 0;
	}
	:deep(.el-dialog__close) {
		font-weight: bold;
		color: @black_color;
		font-size: 22/16rem;
	}

	.name {
		height: @navigator_bar_height;

		&.small {
			height: @navigator_bar_height_small;
		}
		&.medium {
			height: @navigator_bar_height_medium;
		}
	}

	.container {
		height: calc(100vh - 46px);
	}
}
</style>
